import { Header } from '@/shared/Header';
import { SpinnerIcon } from '@/shared/components/icons/spinner.icon';
import { useTopProgress } from '@/shared/hooks/useTopProgress';
import { Title } from '../../../../Title';
import { usePhoneNumberVerify } from './usePhoneNumberVerify';

interface Props {
  phoneNumber: string;
  onClickBackButton: () => void;
}

export const PhoneNumberVerify = (p: Props) => {
  const { verificationCode, isLoading, formattedPhoneNumber, handleCodeChange, handleKeyDown, handleSubmit, handleWebOTPRequest, singleInputRef } = usePhoneNumberVerify(p);
  useTopProgress(isLoading);

  return (
    <div>
      <Header onClickBackButton={p.onClickBackButton} headerClassName="border-b-[0px]" />

      <div className="mt-[40px] mb-8 space-y-1">
        <Title>
          認証コードを
          <br />
          入力してください
        </Title>
        <p className="text-sm text-gray-400 font-light">{formattedPhoneNumber}宛にSMSで認証コードを送りました</p>
      </div>

      <div className="relative">
        <input
          ref={singleInputRef}
          type="text"
          autoComplete="one-time-code"
          value={verificationCode}
          onChange={handleCodeChange}
          onKeyDown={handleKeyDown}
          onFocus={handleWebOTPRequest}
          className="absolute w-full h-[44px] opacity-0 pointer-events-none"
          inputMode="numeric"
          pattern="\d{6}"
          maxLength={6}
          tabIndex={-1}
          aria-hidden="true"
        />

        <div className="grid grid-cols-6 gap-4">
          {[0, 1, 2, 3, 4, 5].map((digitIndex) => (
            <button
              key={`digit-${digitIndex}`}
              type="button"
              className={`w-full aspect-square text-center border-b ${
                verificationCode[digitIndex] ? 'border-gray-600' : 'border-gray-300'
              } focus-within:border-primary text-2xl font-light rounded-none flex items-center justify-center cursor-text bg-transparent`}
              onClick={() => singleInputRef.current?.focus()}
            >
              {verificationCode[digitIndex] || ''}
            </button>
          ))}
        </div>

        {/* TODO: 再送信処理. api側でrate limitもかけたい */}
        {/* <div className="flex items-center space-x-4 mt-4 tracking-wide">
          <span className="text-sm font-light">SMSが届きませんでしたか？</span>
          <button type="button" onClick={() => {}} className="text-sm font-light underline">
            再送信
          </button>
        </div> */}

        <div className="mt-[40px]">
          <button
            type="button"
            onClick={handleSubmit}
            disabled={verificationCode.length !== 6 || isLoading}
            className="flex w-full p-4 bg-gray-100 text-gray-400 font-semibold rounded-[2px] font-medium disabled:opacity-90 enabled:bg-primary enabled:text-white transition-colors justify-center items-center"
          >
            {isLoading ? <SpinnerIcon className="w-5 h-5" /> : '次へ進む'}
          </button>
        </div>
      </div>
    </div>
  );
};
